import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .init({
    // we init with resources
    resources: {
      en: {
        translations: {
          'Token Generator': 'Token Generator',
          'Generate Instagram Token': 'Generate Instagram Token',
          'Your token was successfully generated': 'Your token was successfully generated',
          'Your token was successfully generated_plural': 'Your tokens were successfully generated',
          'Ops! Something went wrong': 'Ops! Something went wrong',
          'Loading': 'Loading',
          'text.reloadToTryAgain':
            `If you wanna try again, please <1>reload</3> this page.`,
          'You have denied the required access.': 'You have denied the required access.',
          // instagram
          'text.instagram.introduction':
            `In order to see your Instagram posts being automatically displayed in Digital Signage Screens powered
            by <1>DSPLAY - Digital Signage</1>, you need to generate a Token
            which provides <3>read-only</3> access to your Instagram <5>Basic Profile</5> and <7>Media</7>.`,
          
          'You haven\'t allowed DSPLAY to read your Instagram media.': 'You haven\'t allowed DSPLAY to read your Instagram media.',
        }
      },
      pt: {
        translations: {
          'text.app.intro':
            `O <1>Gerador de Token DSPLAY</1> permite a você visualizar seus dados de aplicações/serviços externos nas telas gerenciadas pela plataforma <3>DSPLAY - Digital Signage</3>.`,
          'Please select the application/service you want to integrate with': 'Por favor selecione a aplicação/serviço com a qual deseja se integrar',
          'Token Generator': 'Gerador de Token',
          'Your token was successfully generated': 'Seu token foi gerado com sucesso',
          'Ops! Something went wrong': 'Ops! Alguma coisa deu errado',
          'Loading': 'Carregando',
          'text.reloadToTryAgain':
            `Se você quiser tentar novamente, por favor <1>recarregue</3> esta página.`,
          'You have denied the required access.': 'Você negou alguma das permissões necessárias.',
          'Congratulations': 'Parabéns',
          'Copy to Clipboard': 'Copiar Token',
          // instagram
          'Generate Instagram Token': 'Gerar Token do Instagram',
          'text.instagram.introduction':
            `Para que suas postagens no Instagram sejam automaticamente mostradas nas telas de Sinalização Digital gerenciadas
            por <1>DSPLAY - Digital Signage</1>, você precisa gerar um Token
            que provê acesso <3>somente-leitura</3> as informações básicas do seu <5>Perfil</5> e <7>Mídias</7> no Instagram.`,
          'text.instagram.explanation': `Após clicar no botão abaixo, esta página irá te redirecionar para o Instagram, lá será pedido que você autorize a plataforma <1>DSPLAY - Digital Signage</1> a
            ler os dados básicos da sua conta do Instagram.`,
          'text.instagram.conclusion': `Se tudo correr bem, você será mandado de volta para esta página com o seu Token pronto.
            Você pode revogar esta autorização a qualquer momento a partir das <1>configurações</1> da sua conta do Instagram.`,
          'You haven\'t allowed DSPLAY to read your Instagram media.': 'Você não autorizou o DSPLAY a ler suas mídias no Instagram',
          'text.instagram.revoke-note': `Você pode revogar esta autorização a qualquer momento a partir das <1>configurações</1> da sua conta do Instagram.`,
        }
      },
    },
    fallbackLng: "en",
    debug: true,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false, // not needed for react!!
      formatSeparator: ","
    },

    react: {
      wait: true
    }
  });

export default i18n;